
import { supabase } from '@/integrations/supabase/client';
import { useAuthStore } from '../authStore';
import { ChatState } from './types';
import { trackEvent } from '@/services/analytics';

export const createReactionOperations = (set: any, get: () => ChatState) => ({
  addReaction: async (messageId: string, emoji: string): Promise<void> => {
    const user = useAuthStore.getState().user;
    if (!user) {
      console.error('User not logged in');
      return;
    }
    
    try {
      // First, check if the message exists and get its type
      const { data: message, error: messageError } = await supabase
        .from('chat_messages')
        .select('message_type')
        .eq('id', messageId)
        .single();
      
      if (messageError) {
        console.error('Error fetching message for reaction:', messageError);
        return;
      }
      
      const { error } = await supabase
        .from('chat_message_reactions')
        .insert({
          message_id: messageId,
          user_id: user.id,
          emoji
        });
      
      if (error) {
        console.error('Error adding reaction:', error);
      } else {
        // Track reaction added event with enhanced properties
        trackEvent('chat_reaction_added', {
          message_id: messageId,
          emoji,
          message_type: message?.message_type,
          store_id: get().currentStoreId
        });
      }
      
    } catch (error) {
      console.error('Error in addReaction:', error);
    }
  },
  
  removeReaction: async (reactionId: string): Promise<boolean> => {
    try {
      const { error } = await supabase
        .from('chat_message_reactions')
        .delete()
        .eq('id', reactionId);
      
      if (error) {
        console.error('Error removing reaction:', error);
        return false;
      }
      
      trackEvent('chat_reaction_removed', {
        reaction_id: reactionId,
        store_id: get().currentStoreId
      });
      
      return true;
    } catch (error) {
      console.error('Error in removeReaction:', error);
      return false;
    }
  },
});
